import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=7aaa1a04&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=7aaa1a04&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa1a04",
  null
  
)

export default component.exports